export default {
  rowLabel: "client {{name}}",
  successfulClientUpdate: "Client updated successfully",
  deleteSuccess: "Client deleted successfully",
  confirmDeleteTitle: "Delete Client",
  confirmDeleteTitle_plural: "Delete Clients",
  confirmDeleteMessage: "Are you sure you want to delete this client?",
  confirmDeleteMessage_plural:
    "Are you sure you want to delete these {{count}} clients?",
  deleteError:
    "Sorry, this client could not be deleted due to an error on our end. Please try again later.",
  name: "Name",
  email: "Email",
  contacts: "Contacts",
  addContact: "Add Contact",
  editContact: "Edit Contact",
  deleteContact: "Delete Contact",
  firstName: "First Name",
  lastName: "Last Name",
  contactEmail: "Email",
  contactPhone: "Phone",
  createNewContact: "Create Contact",
  successfulContactCreate: "Contact created successfully",
  successfulContactUpdate: "Contact updated successfully",
  confirmDeleteContactTitle: "Delete Contact",
  confirmDeleteContactMessage: "Are you sure you want to delete this contact?",
  deleteContactSuccess: "Contact deleted successfully",
  deleteContactError:
    "Sorry, this contact could not be deleted due to an error on our end. Please try again later.",
  noContacts: "No contacts",
  noContactsMessage:
    "This client doesn't have any contacts yet. Add one to get started.",
  contactTypes: "Types",
  contactTypesLabel: "Contact types",
  contactTypesPlaceholder: "Select types...",
  contactTypesDescription:
    "Types control which client-facing emails (invoices, reminders, receipts) this contact receives. Leave empty to send no emails to this contact.",
  contactTypesEmptyHint: "This contact won't receive any emails.",
  contactTypesManage: "Manage types",
  contactTypesRefresh: "Refresh",
  contactTypesUpgradeToManage: "Upgrade to Pro to manage contact types",
};
